module.exports = {
  "id": "98ab6bdb-af31-40dc-af66-4d1067f9b55d",
  "gtmIds": [
    "GTM-MZQXKJ39",
    "GTM-ND3K4Z5G"
  ],
  "startTracking": "since_launch",
  "hasInAppVersion": false,
  "group": "TLML",
  "language": "fr-FR",
  "defaultDateFormat": "WEEKDAY_SHORT_MONTH_SHORT_DAY_INTL",
  "defaultNumberFormat": null,
  "pricingSavingsAmountPrecision": "exact",
  "checkoutTaxesFeesBreakdownDisplayMode": "modal",
  "languages": [
    "fr-FR",
    "en-US",
    "de-DE"
  ],
  "website": "https://tlml.ch",
  "imageDeliveryUrl": "public-assets.spotliodata.com"
}